import { useState } from "react";

interface SitemapType {
  title: string;
  url: string;
}

interface SitemapProps {
  title: string;
  titleClassName?: string;
  spacing?: string;
  // contentList: {title?:string, link?:string}[] ;
  contentList: SitemapType[];
  isCollapseNeed?: boolean;
}

const Sitemap: React.FC<SitemapProps> = ({
  title,
  titleClassName,
  spacing,
  contentList,
  isCollapseNeed = true,
}) => {
  const [mobileShow, setMobileShow] = useState(!isCollapseNeed);

  return (
    <div className={`flex flex-col ${spacing ?? "space-y-2"}`}>
      <div className={`font-bold ${titleClassName} md:block hidden`}>
        {title}
      </div>
      <div
        className="flex flex-row justify-between font-bold md:hidden block"
        onClick={() => setMobileShow(!mobileShow)}
      >
        <div className={`${titleClassName}`}>{title}</div>
        <div className={isCollapseNeed ? "" : "hidden"}>
          {mobileShow ? "-" : "+"}
        </div>
      </div>
      <div
        className={`${mobileShow ? "block" : "hidden"} flex flex-col ${spacing ?? "space-y-2"} md:block`}
      >
        {contentList.map(({ title, url }, index) => (
          <div key={`${title}-sitemap-${index}`}>
            <a
              className="hover:underline cursor-pointer text-sm"
              href={url}
              target="_blank"
            >
              {title}
            </a>
          </div>
        ))}
        {/* {contentList.map((e) => (
          <div
            key={`${e.title}-${e.url}`}
            className="hover:underline cursor-pointer text-sm"
          >
            {e.title}
          </div>
        ))} */}
      </div>
    </div>
  );
};

export default Sitemap;
